export default "__VITE_ASSET__DuAaM2gI__"